import { createRouter, createWebHistory } from 'vue-router'
	//import { createRouter, createWebHashHistory} from 'vue-router'
import Home from '../views/Home'
import Navigation from '../views/Navigation'
import AmlCll from '../views/AmlCll'
import Store from '../store/index'

const requireAuth = (to,from,next) => {

	console.log(from)

	let token = to.query.token || ''

	function checkToken(token) {
		var base64Url = token.split('.')[1];
		var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
		jsonPayload = JSON.parse(jsonPayload)

		if(typeof jsonPayload === 'string'){
			jsonPayload = JSON.parse(jsonPayload)
		}

		var date = new Date();
		var timestamp = Math.floor(date.getTime()/1000.0);
			console.log(timestamp)

		if(jsonPayload.email){ 
			// *** correct is: && timestamp <= jsonPayload.exp
			Store.dispatch('setLogin',jsonPayload.id)
			document.cookie = "abt_id=" + jsonPayload.id + " expires=" + new Date(new Date().getTime() + 60 * 60 * 24 * 1000) + " path=/";
			next()
		} else {
			// remove check, proceed anyway
			// next({ name: 'Error' })
			next()
		}
	}

	function getCookie(cname) {
		let name = cname + "=";
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for(let i = 0; i <ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	if(Store.getters.userInfo === null){
		if(token){
			checkToken(token)
		} else {

			var cookie = getCookie('abt_id')

				if(!cookie){
					// remove check, proceed anyway
					// next({ name: 'Error' })
					next()
				} else {
					cookie = cookie.split(" expires=")
					cookie[1] = cookie[1].split(' path=/')
					Store.dispatch('setLogin',cookie[0])

					//var d1 = new Date();
					//var d2 = new Date(cookie[1]);
					
					//console.log(d1.getTime())
					// console.log('___')
					// console.log(cookie[1][0])
					// console.log('___')
				}


			if(cookie[0]){
				next()
			} else {
				// remove check, proceed anyway
				//next({ name: 'Error' })
				next()
			}

		}
	} else {
		next()
	}

}



const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		beforeEnter: requireAuth,
		redirect: '/title-screen/1',
		children: [
			{
				path: 'title-screen/:id',
				name: 'Title Screen Index',
				component: () => import('../views/TitleSlides'),
				meta: {
					title: 'AbbVie USMA Clinical Management Center | Home'
				},
			}
		]
	},
	{
		path: '/navigation',
		name: 'Navigation',
		component: Navigation,
		beforeEnter: requireAuth,
		meta: {
			title: 'AbbVie USMA Clinical Management Center | Navigation'
		}
	},
	{
		path: '/aml-cll',
		name: 'AML - CLL',
		component: AmlCll,
		beforeEnter: requireAuth,
		meta: {
			title: 'AbbVie USMA Clinical Management Center'
		},
		children: [
			{
				path: 'intro/:which',
				name: 'Intro Index',
				component: () => import('../views/IntroScreen')
			}
		]
	},
	{
		path: '/patient/:which',
		name: 'Patient',
		beforeEnter: requireAuth,
		component: () => import('../views/Patient'),
		meta: {
			title: 'AbbVie USMA Clinical Management Center'
		},
		children: [
			{
				path: 'diagnosis/',
				name: "Diagnosis",
				component: () => import('../views/Patient/Diagnosis')
			},
			{
				path: 'risk-assessment/',
				name: "Risk Assessment",
				component: () => import('../views/Patient/RiskAssessment')
			},
			{
				path: 'pre-initiation/',
				name: "Pre-initiation",
				component: () => import('../views/Patient/PreInitiation')
			},
			{
				path: 'ramp-up/',
				name: "Ramp-up",
				component: () => import('../views/Patient/RampUp')
			},
			{
				path: 'cycle-1/',
				name: "Cycle One",
				component: () => import('../views/Patient/CycleOne')
			},
			{
				path: 'cycle-2/',
				name: "Cycle Two",
				component: () => import('../views/Patient/CycleTwo')
			},
			{
				path: 'cycle-3/',
				name: "Cycle Three",
				component: () => import('../views/Patient/CycleThree')
			},
			{
				path: 'cycle-4/',
				name: "Cycle Four",
				component: () => import('../views/Patient/CycleFour')
			},
			{
				path: 'final/',
				name: "Final",
				component: () => import('../views/Patient/FinalScreen'),
				meta: {
					hideNav: true
				}
			}
		]
	},
	{
		path: '/neutropenia/',
		name: 'Neutropenia',
		beforeEnter: requireAuth,
		component: () => import('../views/Neutropenia'),
		meta: {
			title: 'AbbVie USMA Clinical Management Center'
		}
	},
	{
		path: '/calendars',
		name: 'Calendars',
		beforeEnter: requireAuth,
		component: () => import('../views/Calendars'),
		meta: {
			title: 'AbbVie USMA Clinical Management Center'
		},
		children: [
			{
				path: ':which',
				component: () => import('../views/Calendars/Ven')
			}
		]
	},
	// {
	// 	path: '/coffee-break/:which/',
	// 	name: 'Coffee Break',
	// 	component: () => import('../views/CoffeeBreak'),
	// 	children: [
	// 		{
	// 			path: '',
	// 			name: 'Coffee Intro',
	// 			component: () => import('../views/Teaser/Intro')
	// 		},
	// 		{
	// 			path: 'question/',
	// 			name: 'Coffee Question',
	// 			component: () => import('../views/Teaser/Question')
	// 		},
	// 	]
	// },
	{
		path: '/error',
		name: 'Error',
		component: () => import('../views/Error.vue'),
		meta: {
			title: 'AbbVie USMA Clinical Management Center | Error'
		}
	},
	{
		path: '/:catchAll(.*)',
		name: 'Not Found',
		component: () => import('../views/NotFound.vue'),
		meta: {
			title: 'AbbVie USMA Clinical Management Center | Not Found'
		}
	}
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	//history: createWebHashHistory(process.env.BASE_URL),
	routes
})

router.beforeEach((to, from, next) => {

	const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

	let additional_meta = ''

	if(to.params.which){
		switch(to.params.which){
			case 'pierce':

				if(to.name === 'Intro Index'){
					additional_meta = ' | Pierce | Intro'
				} else {
					additional_meta = ' | Pierce | ' + to.name 
				}
			break

			case 'carson':
				if(to.name === 'Intro Index'){
					additional_meta = ' | Carson | Intro'
				} else {
					additional_meta = ' | Carson | ' + to.name 
				}
			break

			case 'neutropenia':
				if(to.name === 'Intro Index'){
					additional_meta = ' |  Neutropenia Management Center | Intro'
				} else {
					additional_meta = ' |  Neutropenia Management Center'
				}
			break

			case 'bishop':
				if(to.name === 'Intro Index'){
					additional_meta = ' | Bishop | Intro'
				} else {
					additional_meta = ' | Bishop | ' + to.name 
				}
			break

			case 'gordon':
				if(to.name === 'Intro Index'){
					additional_meta = ' | Gordon | Intro'
				} else {
					additional_meta = ' | Gordon | ' + to.name 
				}
			break

			case 'calendars':
				if(to.name === 'Intro Index'){
					additional_meta = ' | Initiation Calendars | Intro'
				} else {
					additional_meta = ' | Initiation Calendars'
				}
			break

		}
	}

	if(nearestWithTitle) {
		document.title = nearestWithTitle.meta.title + additional_meta;
	}

	next()

})

export default router
